var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .info-blink {\n    animation: infoBlink 1s infinite;\n  }\n  \n  .info-pulse {\n    animation: infoPulse 1.5s infinite;\n  }\n  \n  .info-shake {\n    animation: infoShake 0.5s infinite;\n  }\n  \n  .info-glow {\n    animation: infoGlow 2s infinite;\n  }\n  \n  @keyframes infoBlink {\n    0%, 50% { opacity: 1; }\n    51%, 100% { opacity: 0.3; }\n  }\n  \n  @keyframes infoPulse {\n    0% { opacity: 1; transform: scale(1); }\n    50% { opacity: 0.7; transform: scale(1.1); }\n    100% { opacity: 1; transform: scale(1); }\n  }\n  \n  @keyframes infoShake {\n    0%, 100% { transform: rotate(0deg); }\n    25% { transform: rotate(-2deg); }\n    75% { transform: rotate(2deg); }\n  }\n  \n  @keyframes infoGlow {\n    0%, 100% { filter: drop-shadow(0 0 0px currentColor); }\n    50% { filter: drop-shadow(0 0 6px currentColor); }\n  }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "info-blink"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlink);
export default __webpack_public_path__ + "static/media/infoBlink.8e95ef2cd354cba1bd375b43f79834ad.svg";
export { ForwardRef as ReactComponent };